<template>
  <div>
    <SGPModalComponent
      v-if="mostrarModal"
      tamanho="xs"
      @sgpModalFechar="mostrarModal = false"
    >
      <SGPRowComponent no-gutters>
        <SGPColComponent>
          <h2 style="margin-top: -20px;">Filtrar Colunas</h2>
          <label style="text-align: justify;" class="mt-3 mb-3">
            Selecione as colunas que deseja exibir na tabela marcando as opções disponíveis. Em seguida, arraste para ordenar: a posição de cada coluna definirá a ordem em que serão exibidas.
          </label>
          <h6 class="mb-2">Colunas selecionadas</h6>
          <v-checkbox
            class="p-1 mb-2"
            v-model="selectAllColunas"
            :label="selectAllColunas ? 'Desmarcar todos' : 'Selecionar todos'"
            hide-details
          ></v-checkbox>
          <draggable
              v-model="colunasSelecionadas"
              draggable=".item"
              @start="isDragging=true" @end="isDragging=false; ordenaManual()"
            >
            <v-card
                class="item p-2 mt-1"
                v-for="coluna in colunasSelecionadas"
                :key="coluna"
                 style="cursor: move !important;"
                >
                <SGPRowComponent no-gutters>
                  <SGPColComponent cols="10">
                      <v-checkbox
                        style="margin-top: 0px !important;"
                        v-model="colunasSelecionadas"
                        :label="colunasTabela.filter(col => col.key == coluna)[0].label"
                        :value="coluna"
                        hide-details></v-checkbox>
                  </SGPColComponent>
                  <SGPColComponent cols="2" class="text-center pt-1">
                    <v-icon>
                      mdi-drag-vertical
                    </v-icon>
                  </SGPColComponent>
                </SGPRowComponent>
              </v-card>
          </draggable>
        </SGPColComponent>
        <hr class="mt-4">
        <SGPColComponent cols="12">
          <h6>Colunas não selecionadas</h6>
          <v-checkbox
            v-for="coluna in sanitizarColunas().filter(coluna => !this.colunasSelecionadas.includes(coluna.key))"
            :key="coluna.key"
            v-model="colunasSelecionadas"
            :label="coluna.label"
            :value="coluna.key"
            hide-details
          ></v-checkbox>
        </SGPColComponent>
      </SGPRowComponent>
      
    </SGPModalComponent>

    <SGPConfirmacaoComponent 
      :mostrarModal="confirmacaoBloco" 
      :titulo="'Agrupar'"
      :mensagem="'Tem certeza que deseja agrupar as tarefas selecionadas em bloco?'"
      :txtConfirmar="'Sim, agrupar em bloco'"
      @sgpConfirmarEmit="confirmarBloco()"
      @sgpCancelarEmit="confirmacaoBloco = false"
    />

    <SGRowComponent no-gutters class="mb-2">
      <SGPColComponent cols="12">
        <label class="text-center">{{ selecionados.length }} selecionado(s)</label>
      </SGPColComponent>
    </SGRowComponent>

    <SGPRowComponent no-gutters class="mt-2">
      <SGPColComponent cols="8" >
        <SGPFormBotaoComponent
          class="mr-2"
          color="primary"
          @click="deletarSelecionado"
          v-if="selecionados.length > 1 && usuarioPodeExcluir && !somenteLeitura"
          
        >
          <v-icon class="mr-3" medium>mdi-format-list-checks</v-icon> Deletar selecionados
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent 
          class="mr-2"
          v-if="usuarioPodeAtribuir && selecionados.length"
          color="primary"
          @click.prevent="atribuirSelecionado"
          
        >
          Atribuir
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent v-if="podeAdotar()" @click="adotar" class="mr-2">
          Adotar
        </SGPFormBotaoComponent>
        
        <SGPFormBotaoComponent v-if="podeLiberar()" @click="devolverParaFila" class="mr-2">
          Liberar Tarefa
        </SGPFormBotaoComponent>
        
        <SGPFormBotaoComponent v-if="podeApropriar()" @click="apropriar" class="mr-2">
          Apropriar
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent
          class="mr-2"
          v-if="selecionados.length > 1 && usuarioPodeAgrupar"
          color="primary"
          @click="confirmacaoBloco=true"
          
        >
          Agrupar
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent 
          v-if="usuarioTemPerfilCEC && selecionados.length"
          class="mr-2"
          @click="assumirComoCEC">
          Assumir como CEC
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent
          v-if="usuarioPodeSolicitarCancelamento && selecionados.length"
          @click="$emit('solicitarCancelamentoEmit')"
          color="primary"
        >
          Atualização
        </SGPFormBotaoComponent>
      </SGPColComponent>
      <!-- <SGPColComponent cols="4" v-if="filtroText">
          <SGPFormInputComponent
            type="text"
            v-model="filter"
            placeholder="Buscar..."
            append-icon="mdi-magnify"
            outlined
            dense
          />
      </SGPColComponent> -->

      <SGPColComponent cols="4" v-if="filtroText">
          <SGPFormInputComponent
            type="text"
            v-model="filter"
            placeholder="Buscar..."
            append-icon="mdi-magnify"
            outlined
            dense
          />
      </SGPColComponent>

      <SGPColComponent cols="12" id="responsive-table">

        <v-data-table
          ref="advancedTable"
          id=""
          v-model="selecionados"
          :headers="colunasTabela"
          :items="dadosFiltered"
          :single-select="false"
          :item-key="itemKey"
          items-per-page="-1"
          class="advanced-table elevation-0 mt-3"
          hide-default-footer
          v-bind="$attrs"
          v-on="$listeners"
          disable-pagination
          :show-select="selecionavel"
          :custom-sort="customSort"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @update:options="selecionarTodos(false)"
          :multi-sort="ordenacaoMultipla"
          :search="filter"
          @current-items=" (currentItems) ? limparSelecionados() : false "
          :item-class= "rowClass"   
        >

          <template v-slot:top>
            <div class="top-scroll">
              <div class="scroll"></div>
            </div>
          </template>

          <template v-slot:body.prepend v-if="filtrarTabela">
            <tr style="height: 50px;">
              <td class="text-center">

              </td>
              <td 
                v-for="(header, index) in colunasTabela"
                :key="index"
                :class="`text-${header.align}`"
                :style="`padding: 5px; width: ${parseInt(header.width)}px; min-width: ${parseInt(header.width)}px;`">
                <input 
                  v-model="filters[header.key]"
                  @input="filtrarColuna(header.key)"
                  v-if="header.filterable != false"
                  type="text"
                  class="form-control input-filtro"
                  style="width: 100%; height: 40px;"/>
              </td>
            </tr>
          </template>
          <!-- <template v-slot:header>
            <thead class="v-data-table-header">
              <tr style="height: 54px;" >
                <th
                  style="width: 120px !important; display: flex; align-items: center; justify-content: center; height: 54px;"
                >
                  <span
                    v-if="selecionados.length"
                    :style="
                      `position: absolute;
                      left: 5px;
                      top: 2px;
                      padding-top: ${(selecionados.length > 99) ? '3px' : '0px'};
                      padding-bottom: ${(selecionados.length > 99) ? '3px' : '0px'};
                      border-radius: 50%;
                      background-color: yellow;
                      width:${(selecionados.length > 99) ? '30px' : '20px'};
                      text-align: center;
                      z-index: 1000;
                      color: #000;`"
                  >
                    {{ (selecionados.length > 99) ? '+99' : selecionados.length }}
                  </span>
                  <v-simple-checkbox
                    color="white"
                    v-model="selectAll"
                    class="float-left mt-2"
                  />
                  <v-btn
                    v-if="selecionarColunas"
                    class="float-left"
                    text
                    icon
                    :color="colunasSelecionadas.length ? 'black' : 'grey-2'"
                    @click="mostrarModal = !mostrarModal"
                    middle
                  >
                    <v-icon class="mt-1">mdi-tune</v-icon>
                  </v-btn>
                </th>
                <th
                  v-for="(header, index) in colunasTabela"
                  :key="index"
                  :class="`text-${header.align}`"
                  :style="
                    `position:relative;
                    width: ${parseInt(header.width) + 50}px; 
                    min-width: ${parseInt(header.width) + 50}px;`"
                >
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div>
                      <span>{{ header.text }} </span>
                    </div>
                    <div class="actions-header text-left" style="width: 70%;">
                      <SGPIconComponent
                        v-if="header.sortable"
                        small
                        class="icon-sortable mr-1"
                        @click="ordenarColuna(header.value, !sortBy.includes(header.value))"
                        color="black"
                        :icon="(sortBy.includes(header.value)) ? 'mdi-arrow-up' : 'mdi-arrow-down'"></SGPIconComponent>
                      <v-menu
                        v-if="header.filterable"
                        offset-y
                        open-on-click
                        :close-on-content-click="false"
                      >
                        <template v-slot:activator="{ on, attrs, value }">
                          <v-icon
                            :style="(
                              (
                                filters[header.value] != '' && filters[header.value] != undefined
                              ) 
                                || value
                              ) ? 'opacity: 1;' : ''"
                            class="icon-filter"
                            small
                            color="black"
                            dark
                            v-bind="attrs"
                            v-on="on">mdi-filter</v-icon>
                        </template>
  
                        <v-card style="min-width: 200px;">
                          <v-card-title class="text-subtitle-1">{{ header.text }}</v-card-title>
                          <v-card-text>
                            <v-text-field
                              v-model="filters[header.value]"
                              @input="filtrarColuna(header.value)"
                              label="Digite aqui"
                              dense
                              hide-details
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </template> -->

          <template v-slot:header.data-table-select="{ on , props }">
            <th class="text-center" style="position: relative;">
              <span
                v-if="selecionados.length"
                :style="
                  `position: absolute;
                  left: -5px;
                  top: 2px;
                  padding-top: ${(selecionados.length > 99) ? '3px' : '0px'};
                  padding-bottom: ${(selecionados.length > 99) ? '3px' : '0px'};
                  border-radius: 50%;
                  background-color: yellow;
                  width:${(selecionados.length > 99) ? '30px' : '20px'};
                  text-align: center;
                  z-index: 1000;
                  color: #000;`"
              >
                {{ (selecionados.length > 99) ? '+99' : selecionados.length }}
              </span>
              <v-simple-checkbox
                color="white"
                v-bind="props"
                v-on="on"
                class="float-left mt-2"
              />
              <v-btn
                v-if="selecionarColunas"
                class="float-left"
                text
                icon
                :color="colunasSelecionadas.length ? 'black' : 'grey-2'"
                @click="mostrarModal = !mostrarModal"
                middle
              >
                <v-icon class="mt-1">mdi-tune</v-icon>
              </v-btn>
              <v-btn
                  class="float-left ml-1 "
                  text
                  icon
                  middle
                  @click="filtrarTabela = !filtrarTabela"
                  >
                <v-icon
                  class="mt-1"
                >
                  {{ (filtrarTabela) ? 'mdi-filter' : 'mdi-filter-outline' }}
                </v-icon>
              </v-btn>
            </th>
          </template>

          <template v-slot:item.visualizar_aba="{ item }">
            <SGPFormBotaoComponent
              :href="item.visualizar_aba"
              x-small
              fab
              color="warning"
              class="mt-1 mb-1"
            >
              <v-icon
              >
                mdi-link
              </v-icon>
            </SGPFormBotaoComponent>
          </template>

          <template v-slot:item.selecionar="{ item }">
            <div class="container-botao-tabela" v-if="!somenteLeitura">
              <SGPFormBotaoComponent
                fab
                rounded
                color="warning"
                @click="editarItem(item)"
                v-if="usuarioPodeEditar"
                x-small
                :disabled="item.deleted_at"
              >
                <v-icon color="white" small>mdi-pencil</v-icon>
              </SGPFormBotaoComponent>
              
              <SGPFormBotaoComponent
                class="ml-2"
                fab
                rounded
                color="primary"
                @click="excluirItem(item)"
                v-if="usuarioPodeExcluir"
                x-small
                :disabled="item.deleted_at"
              >
                <v-icon color="white" small>mdi-delete</v-icon>
              </SGPFormBotaoComponent>
            
              <SGPFormBotaoComponent
                v-if="usuarioPodeRestaurar"
                fab
                rounded
                color="black"
                @click="restaurarSelecionado(item)"
                :disabled="!item.deleted_at"
                x-small
                class="ml-2"
              >
                <v-icon color="white" small>mdi-backup-restore</v-icon>
              </SGPFormBotaoComponent>
            </div>
          </template>

          <!-- <template v-slot:header.data-table-select="">
            <div style="width: 68px;"> 
              <v-checkbox
                label=""
                class="float-left"
                v-model="selectAll"
                color="white"
                @click="selecionarTodos(val)"
              ></v-checkbox>

              <v-btn
                v-if="selecionarColunas"
                class="float-left mt-3"
                text
                icon
                :color="colunasSelecionadas.length ? 'black' : 'grey-2'"
                @click="mostrarModal = !mostrarModal"
                middle
              >
                <v-icon middle class="mt-1">mdi-tune</v-icon>
              </v-btn>
            </div>          
          </template>

          <template slot="item" slot-scope="props">
            <tr>
              <template v-for="(header, index) in props.headers">
                <td :class="`text-${header.align}`" :key="header.key">
                  <v-checkbox
                    v-if="index === 0"
                    label=""
                    v-model="selecionados"
                    :value="props.item"
                    class="float-left mt-0"
                    color="primary"
                    :key="header"
                    hide-details
                    multiple
                  ></v-checkbox>

                  <SGPFormBotaoComponent
                    v-else-if="header.key === 'visualizar_aba'"
                    :href="props.item[header.key]"
                    x-small
                    fab
                    color="warning"
                    class="mt-1 mb-1"
                  >
                    <v-icon
                    >
                      mdi-link
                    </v-icon>
                  </SGPFormBotaoComponent>

                  <div class="container-botao-tabela" v-else-if="header.key === 'selecionar' && !somenteLeitura">
                      <SGPFormBotaoComponent
                        fab
                        rounded
                        color="warning"
                        @click="editarItem(props.item)"
                        v-if="usuarioPodeEditar"
                        x-small
                        :disabled="props.item.deleted_at"
                      >
                        <v-icon color="white" small>mdi-pencil</v-icon>
                      </SGPFormBotaoComponent>
                      
                      <SGPFormBotaoComponent
                        class="ml-2"
                        fab
                        rounded
                        color="primary"
                        @click="excluirItem(props.item)"
                        v-if="usuarioPodeExcluir"
                        x-small
                        :disabled="props.item.deleted_at"
                      >
                        <v-icon color="white" small>mdi-delete</v-icon>
                      </SGPFormBotaoComponent>
                   
                      <SGPFormBotaoComponent
                        v-if="usuarioPodeRestaurar"
                        fab
                        rounded
                        color="black"
                        @click="restaurarSelecionado(props.item)"
                        :disabled="!props.item.deleted_at"
                        x-small
                        class="ml-2"
                      >
                        <v-icon color="white" small>mdi-backup-restore</v-icon>
                      </SGPFormBotaoComponent>
                    </div>
                  
                  <span :class="`text-${header.align}`" v-else>
                    <span v-html="sanitizeValue(props.item[header.key], header.stringConcat)"></span>
                  </span>
                </td>
              </template>
            </tr>
          </template> -->

          <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <div :key="_"> 
              <slot :name="scopedSlotName" v-bind="slotData"></slot>
            </div> 
          </template>
        </v-data-table>
      </SGPColComponent>
      </SGPRowComponent>

      <SGPConfirmacaoRestauracaoComponent
        v-if="abrirModalRestaurar"
        @sgpCancelarRestauracaoEmit="cancelarRestauracao()"
        @sgpConfirmarRestauracaoEmit="confirmarRestauracao()"
      />
  </div>
</template>

<script>
import { concatenarArray } from '@/common/helpers/ArrayHelper.js'
import criarToast from '@/common/boot/ToastsHandler'
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'SGPTabelaAvancadaComponent',

  components: {
    draggable
  },

  props: {
    titulo: {
      type: String,
      required: false,
      default: ''
    },
    
    colunas: {
      type: Array,
      required: true
    },
    
    dados: {
      type: Array,
      required: true
    },
    
    somenteLeitura: {
      type: Boolean,
      required: false,
      default: false
    },
    
    usuarioPodeExcluir: {
      type: Boolean,
      required: false,
      default: true
    },
    
    usuarioPodeEditar: {
      type: Boolean,
      required: false,
      default: true
    },

    usuarioPodeRestaurar: {
      type: Boolean,
      required: false,
      default: true
    },

    usuarioPodeExportar: {
      type: Boolean,
      required: false,
      default: false
    },

    usuarioPodeAgrupar: {
      type: Boolean,
      required: false,
      default: false
    },

    usuarioPodeAtribuir: {
      type: Boolean,
      required: false,
      default: false
    },

    botaoInline: {
      type: Boolean,
      required: false,
      default: false
    },

    aceitaHtml: {
      type: Boolean,
      required: false,
      default: false
    },

    filtroText: {
      type: Boolean,
      required: false,
      default: false
    },

    textoParaFiltragem: {
      type: String,
      required: false,
      default: ''
    },

    itemKey: {
      type: String,
      required: false,
      default: 'id'
    },

    selecionarColunas: {
      type: Boolean,
      required: false,
      default: false
    },

    usuarioTemPerfilCEC: {
      type: Boolean,
      required: false,
      default: false
    },

    colunasOrdenacaoData: {
      type: Array,
      required: false,
      default: () => []
    },

    colunasOrdenacaoAging: {
      type: Array,
      required: false,
      default: () => []
    },

    ordenacaoMultipla: {
      type: Boolean,
      required: false,
      default: false
    },

    rowClass: {
      type: Function,
      required: false,
      default: () => { return '' }
    },

    usuarioPodeSolicitarCancelamento: {
      type: Boolean,
      required: false,
      default: false
    },

    selecionavel: {
      type: Boolean,
      required: false,
      default: true
    },

    currentItems: {
      type: Boolean,
      required: false,
      default: true
    },

    exibeFuncionalidades: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      dadosFiltered: [],
      selecionados: [],
      mostrarModal: false,
      colunasSelecionadas: [],
      colunasTabela: [],
      selectAll: false,
      selectAllColunas: false,
      confirmacaoBloco: false,
      abrirModalRestaurar: false,
      filter: '',
      filters: {},
      filtrarTabela: false,
      filterMenu: {},
      sortBy: [],
      sortDesc: [],
    }
  },

  created () {
    this.selecionados = []
    const cols = this.recuperarColunasLocalStorage()
    this.colunasSelecionadas = []
    if (cols.length) {
      this.colunasSelecionadas = cols
    }
    this.aplicarColunasSelecionadas()
    if (this.colunasSelecionadas.length == this.sanitizarColunas().length) {
      this.selectAllColunas = true;
    }
  },

  mounted () {
    this.selecionados = []
    try {
      let containerTable = document.getElementsByClassName('v-data-table__wrapper')
      let table = containerTable[0].getElementsByTagName('table')
      if (containerTable.length > 1) {
        this.eventScrollMultipleTables(containerTable)
        return
      }

      table[0].addEventListener('mouseenter', () => {
        let tableWidth = table[0].offsetWidth
        let wrapper1 = document.getElementsByClassName('top-scroll');
        let headerS = document.getElementsByClassName('scroll')
        headerS[0].style.width = (tableWidth + 40) + 'px'

        if(wrapper1.length) {
          wrapper1 = wrapper1[0]
        }
        
        wrapper1.addEventListener("scroll", () => {
          containerTable[0].scrollLeft = wrapper1.scrollLeft
        }, { passive: true });

        containerTable[0].addEventListener("scroll", () => {
          wrapper1.scrollLeft = containerTable[0].scrollLeft
        })
      })
    } catch (e) {
      //
    }
  },

  computed: {
    ...mapGetters('atribuirTarefas', [
      'loadingAtribuirTarefas'
    ])
  },

  methods: {
    ...mapActions('atribuirTarefas', [
      'verificarEquipesPorResponsavel',
    ]),

    eventScrollMultipleTables (containerTable) {
      for(let i = 0; i < containerTable.length; i++) {       

        let table = containerTable[i].getElementsByTagName('table')    
        table[0].addEventListener('mouseenter', () => {
          let tableWidth = table[0].offsetWidth
          let wrapper1 = document.getElementsByClassName('top-scroll');

          if (wrapper1.length) {
            wrapper1 = wrapper1[0]
            wrapper1.addEventListener("scroll", () => {
              containerTable[i].scrollLeft = wrapper1.scrollLeft
            }, { passive: true });
          }

          let headerS = document.getElementsByClassName('scroll')
          headerS[i].style.width = (tableWidth + 40) + 'px'

          containerTable[i].addEventListener("scroll", () => {
            wrapper1.scrollLeft = containerTable[i].scrollLeft
          })
        })
      }

     
        
    },

    ordenaManual() {
      const colunasOrdenadas = [];
      this.colunasSelecionadas.forEach(coluna => {
        const index = this.colunasTabela.findIndex(item => item.key === coluna);
        if (index !== -1) {
          colunasOrdenadas.push(this.colunasTabela[index]);
        }
      });
      this.colunasTabela = colunasOrdenadas;
    },

    row_classes (item) {
      if (item.cliente == "SANTANDER") {
        return "black"; //can also return multiple classes e.g ["orange","disabled"]
      } 
    },

    agingsSort(items, keyArray, isDesc) {
      items.sort((a, b) => {
        const key = keyArray[0]
        const isDescOrientation = isDesc[0]

        if(this.colunasOrdenacaoAging.includes(key) && a[key] != '-' && b[key] != '-' ) {
          let agingA = a[key].split(' ')
          let agingB = b[key].split(' ')

          if(agingA.length == 3) {
            agingA = `${agingA[0]}${agingA[2].replace(':','')}`
          } else {
            agingA = agingA[0]
          }

          if(agingB.length == 3) {
            agingB = `${agingB[0]}${agingB[2].replace(':','')}`
          } else {
            agingB = agingB[0]
          }

          if (isDescOrientation) {
            return agingB - agingA
          }

          return agingA - agingB
        }
      })

      return items
    },

    customSort(items, keyArray, isDesc) {
      items.sort((a, b) => {
        const key = keyArray[0]
        const isDescOrientation = isDesc[0]

        if (this.colunasOrdenacaoData.includes(key) && a[key] != '-' && b[key] != '-' && b[key] != 'Invaliddate') {
          let dateA, dateB;
          dateA = a[key].split(' ')
          if(dateA.length > 1) {
            dateA = dateA[0].split('/').reverse().join('') + dateA[1].replace(/:/g,'')
          } else {
            dateA = a[key].split('/').reverse().join('')
          }

          dateB = b[key].split(' ')
          if(dateB.length > 1) {
            dateB = dateB[0].split('/').reverse().join('') + dateB[1].replace(/:/g,'')
          } else {
            dateB = b[key].split('/').reverse().join('')
          }

          if (isDescOrientation) {
            return dateB - dateA
          }

          return dateA - dateB
        } else {
          if (!isDescOrientation) {
            return a[keyArray] < b[keyArray] ? -1 : 1;
          } else {
            return b[keyArray] < a[keyArray] ? -1 : 1;
          }
        }
      })

      this.agingsSort(items, keyArray, isDesc);

      return items
    },
    
    sanitizarColunas () {
      return this.colunas.map(coluna => {
        return {
          ...coluna,
          text: coluna.label,
          value: coluna.key,
          align: coluna.align || 'left',
          width: `${ coluna.width || '' }`
        }
      })
    },


    filtrarColuna(){
      this.dadosFiltered = this.dados.filter(item => {
        return Object.entries(this.filters).every(([chave, valorFiltro]) => {
          if (!valorFiltro) return true; // ignora filtros vazios
          const valorItem = item[chave]?.toString().toLowerCase() || '';
          return valorItem.includes(valorFiltro.toLowerCase());
        });
      });
    },

    sanitizeValue (val, concat = ', ') {   
     return concatenarArray(val, concat)
    },

    aplicarColunasSelecionadas () {
      const colunasOrdenadas = [];
      this.colunasSelecionadas.forEach(coluna => {
        const index = this.sanitizarColunas().findIndex(item => item.key === coluna);
        if (index !== -1) {
          colunasOrdenadas.push(this.sanitizarColunas()[index]);
        }
      });
      this.colunasTabela = colunasOrdenadas
      localStorage.setItem(`${this.$route.fullPath.replace(/\//g, '_').replace(/-/g, '_')}`, JSON.stringify(this.colunasSelecionadas))
    },

    selecionaTodasColunas(val) {
      if (val) {
        const colunasNaoSelecionadas = this.sanitizarColunas().filter(coluna => !this.colunasSelecionadas.includes(coluna.key));
        this.colunasSelecionadas = this.colunasSelecionadas.concat(colunasNaoSelecionadas.map(coluna => coluna.key));
      } else {
        this.colunasSelecionadas = [];
        this.aplicarColunasSelecionadas();
      }
    },

    recuperarColunasLocalStorage () {
      return JSON.parse(localStorage.getItem(`${this.$route.fullPath.replace(/\//g, '_').replace(/-/g, '_')}`))
    },

    selecionarTodos (val) {
      if(val) {
        this.selecionados = this.dados
        return
      }
      this.selecionados = []
    },

    excluirItem (item) {
      this.selecionados = [ item ]
      setTimeout( () => {
        this.deletarSelecionado()
      }, 50)
    },

    deletarSelecionado () {
      this.$emit('sgpTabelaDeletarSelecionadoEmit');
    },

    editarItem (item) {
      this.selecionados = [ item ]
      setTimeout( () => {
        this.editarSelecionado()
      }, 50)

    },

    editarSelecionado () {
      this.$emit('sgpTabelaEditarSelecionadoEmit');
    },

    async confirmarBloco () {
      this.confirmacaoBloco = false;
      const pcoTarefaIds = [];

      this.selecionados.forEach(linha => {
        pcoTarefaIds.push(linha.pco_tarefa_id)
      });

      if (pcoTarefaIds.length > 50) {
        criarToast({
          tipo: 'error',
          mensagem: 'Você deve selecionar no máximo 50 circuitos!'
        })
        return
      }

      this.$emit('sgpTabelaAgruparTarefasEmit', pcoTarefaIds);
    },

    atribuirSelecionado () {
      this.$emit('sgpTabelaAtribuirSelecionadoEmit')
    },

    restaurarSelecionado (item) {
      this.abrirModalRestaurar = true;
      this.itemRestaurar = item;
    },

    confirmarRestauracao () {
      this.$emit('sgpTabelaRestaurarSelecionadoEmit', this.itemRestaurar);
      this.abrirModalRestaurar = false;
    },

    cancelarRestauracao() {
      this.abrirModalRestaurar = false;
    },

    limparSelecionados () {
      this.selecionados = []
    },

    obterPcoTarefaIds () {
      const pcoTarefaIds = [];

      this.selecionados.forEach(linha => {
        pcoTarefaIds.push(linha.pco_tarefa_id)
      });

      return pcoTarefaIds;
    },

    assumirComoCEC () {
      this.$emit('sgpTabelaAssumirComoCECEmit', {pco_tarefa_id: this.obterPcoTarefaIds()});
    },

    podeAdotar() {
      if (this.exibeFuncionalidades == false)
        return false

      if (this.selecionados.length == 0)
        return false

      const finalizados = this.selecionados.filter(selected => selected.finalized_at != null);

      if (finalizados.length > 0)
        return false;

      const userTratamento = this.selecionados.filter(selected => selected.user_tratamento != null && selected.user_tratamento != "");

      if (userTratamento.length > 0)
        return false;

      const tarefaInterrupcao = this.selecionados.filter(selected => selected.tarefa_interrupcao != null && selected.tarefa_interrupcao != "");

      if (tarefaInterrupcao.length > 0)
        return false;

      const solicitacaoCancelamento = this.selecionados.filter(selected => selected.solicitacao_cancelamento == 1);

      if (solicitacaoCancelamento.length > 0)
        return false;

      const aguardandoParalelismo = this.selecionados.filter(selected => selected.status == 'AGUARDANDO_PARALELISMO');

      if (aguardandoParalelismo.length > 0)
        return false;

      return true;
    },

    podeLiberar() {
      if (this.exibeFuncionalidades == false)
        return false

      if (this.selecionados.length == 0)
        return false

      const user = JSON.parse(localStorage['sgp-usuario']); 

      return this.selecionados.filter(selected => selected.user_tratamento != user.nome).length == 0;
    },

    podeApropriar(){
      if (this.exibeFuncionalidades == false)
        return false

      if (this.selecionados.length == 0)
        return false

      const finalizados = this.selecionados.filter(selected => selected.finalized_at != null);

      if (finalizados.length > 0)
        return false;

      const user = JSON.parse(localStorage['sgp-usuario']); 

      return this.selecionados.filter(selected => selected.user_tratamento == user.nome || selected.user_tratamento == "").length == 0;
    },

    adotar () {
      this.$emit('sgpTabelaAdotarSelecionados', {pco_tarefa_id: this.obterPcoTarefaIds()});
    },

    devolverParaFila() {
      this.$emit('sgpTabelaDevolverSelecionados', {pco_tarefa_id: this.obterPcoTarefaIds()});
    },

    apropriar () {
      this.$emit('sgpTabelaApropriarSelecionados', {pco_tarefa_id: this.obterPcoTarefaIds()});
    },

    exiteCanceladoSelecionado () {      
      const cancelados = this.selecionados.filter(selected => selected.solicitacao_cancelamento == 1)
      return cancelados.length
    }
  
  },

  watch: {
    dados: {
      immediate: true,
      handler (dados) {
        this.dadosFiltered = dados
      }
    },

    colunasSelecionadas (val) {
      this.aplicarColunasSelecionadas()
      if(!val.length) {
        this.colunasTabela = this.sanitizarColunas()
      }
    },

    selecionados (val) {
      this.$emit('sgpTabelaLinhasSelecionadasEmit', val)
    },

    selectAll (val) {
      this.selecionarTodos(val)
    },

    selectAllColunas (val) {
      this.selecionaTodasColunas(val)
    }
  }
}
</script>

<style lang="scss">

// .v-data-table { 
//   overflow-x: auto;
// }

#wrapper-scroll-top {
  width: 100%;
  overflow-x: scroll; 
  overflow-y:hidden;
}

#scroll-top {
  height: 1px;
  overflow: scroll;
}

.width-scroll {
  width: 1800px;
}

$redColor: #df323b;

.advanced-table table .v-data-table-header tr th {
  color: #fff;
  background-color: $redColor !important;

  span {
    color: #fff;
    font-size: 13px;
  }
    
  .v-input--selection-controls__input i {
    color: #f8f8f8;
  }
}
.advanced-table table thead tr th:first-child{
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
  padding: 4px 0 8px 0;
}

.advanced-table table thead tr {
  border-left: solid 1px $redColor;
  border-right: solid 1px $redColor;
}

.advanced-table table tbody tr {
  border-left: solid 1px #eee;
  border-right: solid 1px #eee;
}

.advanced-table table tbody tr td{
  margin: 40px 0 !important;
}

.advanced-table table tbody tr:nth-child(even) td {
  background: #f9f9f9;
}

.advanced-table table tbody tr:nth-child(odd) td {
  background: #f6f6f6;
}

.advanced-table table tbody tr:hover td{
  background: #eee;
}

.advanced-table table tbody {
  tr.back-table-alert-color {
    td {
        background-color: #FFE458 ;
    }

    &:hover {
      td {
        background-color: #f8dc08 ;
      }
    }
  }
}

.container-botao-tabela {
  width: 120px;
}

.top-scroll, .table-responsive { 
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y:hidden; 
}
.top-scroll { 
  height: 15px;
}

.scroll { 
  // width: 100%; 
  height: 20px; 
  background-color: #fff;
}
.table-responsive table { 
  width: 100%; 
  max-width: 100%; 
  overflow-x: auto; 
}

.top-scroll {
  margin-bottom: 4px;
  background: #cf5 !important;

  scrollbar-color: #D4AA70 #e4e4e4;

  &::-webkit-scrollbar {
      background-image: linear-gradient(00deg, #fff 2%, #fff 2%);
      box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
      border-radius: 0px;
      height: 12px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 20px;
    background-color: #fff;
  }
    
  &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 2px solid rgba(0, 0, 0, 0.56);
      border-left: 0;
      border-right: 0;
      background-color: rgba(50, 50, 50, 1);
  }
}

.v-data-table__selected td {
  background-color: rgb(220, 220, 220) !important;
}

.input-filtro fieldset {
  height: 40px;
}

</style>